export const validStripeField = (event) => {
  if (!event || (event && (event.error || !event.complete))) return false;
  return true;
};
